<template>
  <div

    class="container"
    cols="12"
    md="6"
    style="padding-bottom: 68px;"
  >
    <div class="row" id="container-filtros-tour">
      <div class="col-4">
        <el-input
          v-model="input"
          suffix-icon="el-icon-search"
          placeholder="Pesquisa por nome"
          @input="pesquisar"
        />
      </div>
      <div class="col-4">
        <el-input
          v-model="input2"
          suffix-icon="el-icon-search"
          placeholder="Pesquisa por tag"
          @input="pesquisarTag"
        />
      </div>
    </div>

    <!-- <pre>{{ playerVideos}}</pre>    -->
    <!-- <pre>{{ folders }}</pre>   -->

    <folders
      v-model="folders"
      @updateVideos="getPlayerVideos($event)"
      @selectVideoFolder="selectFolderVideo($event)"
    />
    <videos
      v-model="playerVideos"
      @selectVideoFolder="selectFolderVideo($event)"
    />
    <BarraCheckBox
      v-model="qtdSelected"
      :checked="isCheckedAll"
      :folders="folders"
      :videos="playerVideos"
      @updatedChecked="inputChecked"
    />
  </div>
</template>
<script>
import BarraCheckBox from '@/components/MenuCheckBox/BarraCheckBox.vue'
import { mapActions, mapState } from 'vuex'
import { useApi } from '@/composables/useApi'
import clearFolderOnExit from '@/mixins/clearFolderOnExit'

import { BInputGroup, BFormInput, BInputGroupPrepend } from 'bootstrap-vue'
import Videos from './Videos.vue'
import Folders from '../Pastas/Folders.vue'
import ModalCriarPastas from '../Pastas/ModalCriarPastas.vue'

const api = useApi()
export default {
  components: {
    ModalCriarPastas,
    Folders,
    Videos,
    BarraCheckBox,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,

  },
  mixins: [clearFolderOnExit],
  data() {
    return {
      input: '',
      input2: '',
      isCheckedAll: false,
      qtdSelected: [],
      folders: [],
      // playerVideos: [],
      // playerVideos: []
    }
  },
  computed: {
    ...mapState('Folders', ['folderAtual']),

    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    playerVideos() {
      return this.$store.state.Videos.AllVideosMain
    },
  },
  beforeDestroy() {
    // Zerar folderATUAL quando o componente for destruído
    console.log('MeusVideos sendo destruído - zerando folderATUAL')
    localStorage.setItem('folderATUAL', JSON.stringify(0))
    this.$store.commit('Folders/setfolderAtual', {
      id: 0,
      folder_name: 'Meus Videos',
      folder_backet_adress: null,
      id_main: null,
      id_user: this.getUserData.id,
      folder_date: null,
      folder_key_name: null,
    })
  },
  beforeRouteLeave(to, from, next) {
    // Zerar folderATUAL quando sair da rota
    console.log('Saindo da rota MeusVideos - zerando folderATUAL')
    localStorage.setItem('folderATUAL', JSON.stringify(0))
    this.$store.commit('Folders/setfolderAtual', {
      id: 0,
      folder_name: 'Meus Videos',
      folder_backet_adress: null,
      id_main: null,
      id_user: this.getUserData.id,
      folder_date: null,
      folder_key_name: null,
    })
    next()
  },
  methods: {
    //  ...mapActions('Videos', ['listarVideos']),
    ...mapActions('Folders', ['getAllFolderUser']),
    inputChecked(val) {
      this.isCheckedAll = val
    },
    selectFolderVideo(item) {
      if (this.qtdSelected.indexOf(item) === -1) {
        this.qtdSelected.push(item)
      } else {
        this.qtdSelected.splice(this.qtdSelected.indexOf(item), 1)
      }
    },
    setFolderATUAL() {
      const atual = 0
      localStorage.setItem('folderATUAL', JSON.stringify(atual))
    },
    async getFoldersAll() {
      const params = {
        id_main: 0,
      }
      await api.get(`/folderUser/${this.getUserData.id}`, {
        params,
      })
        .then(resp => {
          const formData = resp.data
          formData.map(f => f.is_selected = false)
          this.folders = formData
        })
    },
    async getPlayerVideos(id_folder) {
      // this.id_folderAtual = id_folder
      this.isCheckedAll = false
      this.qtdSelected = []
      let params = null
      if (id_folder) {
        params = {
          id_folder: id_folder.id,
        }
      }
      await api.get(`/vslUserId/${this.getUserData.id}`, {
        params,
      })
        .then(resp => {
          const formData = resp.data
          formData.map(v => v.is_selected = false)
          // this.playerVideos = formData
          this.$store.commit('Videos/setVideosMain', formData)
        })
    },

    async pesquisarTag(e) {
      if (this.folders.length === 0) {
        await api.get(`/getTagVslLike?vsl_tag=${e}&id_user=${this.getUserData.id}&id_folder=${this.folderAtual.id}`)
          .then(response => {
            const valor = response.data
            this.$store.commit('Videos/setVideosMain', valor)
          })
        await api.get(`/getFolderLike?folder_name=${e}&id_user=${this.getUserData.id}&id_main=${this.folderAtual.id}`)
          .then(res => {
            this.folders = res.data
          })
      } else {
        await api.get(`/getTagVslLike?vsl_tag=${e}&id_user=${this.getUserData.id}&id_folder=${this.folders[0].id_main}`)
          .then(response => {
            const valor = response.data
            this.$store.commit('Videos/setVideosMain', valor)
          })
        await api.get(`/getFolderLike?folder_name=${e}&id_user=${this.getUserData.id}&id_main=${this.folders[0].id_main}`)
          .then(res => {
            this.folders = res.data
          })
      }
    },
    async pesquisar(e) {
      if (this.folders.length === 0) {
        await api.get(`/getVslLike?vsl_name=${e}&id_user=${this.getUserData.id}&id_folder=${this.folderAtual.id}`)
          .then(response => {
            const valor = response.data
            this.$store.commit('Videos/setVideosMain', valor)
            // console.log("PROPIEDADE PLAYERVIDEOS",this.playerVideos);
          })
        await api.get(`/getFolderLike?folder_name=${e}&id_user=${this.getUserData.id}&id_main=${this.folderAtual.id}`)
          .then(res => {
            this.folders = res.data
            console.log('folder', res.data)
          })
      } else {
        await api.get(`/getVslLike?vsl_name=${e}&id_user=${this.getUserData.id}&id_folder=${this.folders[0].id_main}`)
          .then(response => {
            const valor = response.data
            this.$store.commit('Videos/setVideosMain', valor)
            // console.log("PROPIEDADE PLAYERVIDEOS",this.playerVideos);
          })
        await api.get(`/getFolderLike?folder_name=${e}&id_user=${this.getUserData.id}&id_main=${this.folders[0].id_main}`)
          .then(res => {
            this.folders = res.data
            console.log('folder', res.data)
          })
      }
    },
    // async pesquisar(e) {
    //   await api.get(`/getFolderLike?folder_name=${e}&id_user=${this.getUserData.id}&id_main=${this.folderAtual.id}`)
    //     .then(res => {
    //       this.folders = res.data
    //       console.log('folder',res.data)
    //     });
    // }
  },
  mounted() {
    this.getAllFolderUser()
    this.getFoldersAll(0)
    this.getPlayerVideos({
      id: 0,
    })
    this.setFolderATUAL()
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'meus-videos')
  },
}
</script>
